import axios from "axios";

const apiAdmin = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

apiAdmin.interceptors.request.use((config) => {
  const token = localStorage.getItem("usuario_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

apiAdmin.interceptors.response.use(
  (response) => {
    if (response?.data?.ok === false) {
      const allErrs = Array.isArray(response?.data?.errors)
        ? response.data.errors.map((e) => e?.msg).filter(Boolean).join(" · ")
        : null;

      const msg =
        response?.data?.message ||
        allErrs ||           
        response?.data?.error || 
        "Request failed";

      const err = new Error(msg);
      err.status = 400;
      err.code = response?.data?.code || "REQUEST_FAILED";
      err.data = response?.data;
      throw err;
    }

    return response;
  },
  (error) => {
    const status = error?.response?.status || 0;
    const data = error?.response?.data || null;
    const allErrs = Array.isArray(data?.errors)
      ? data.errors.map((e) => e?.msg).filter(Boolean).join(" · ")
      : null;

    const backendMsg =
      data?.message ||
      allErrs || 
      data?.error ||
      null;

    const message =
      backendMsg ||
      (status === 401 ? "Session expired. Please login again." : null) ||
      (status === 403 ? "You don't have permission to do this." : null) ||
      (status === 404 ? "Resource not found." : null) ||
      (status >= 500 ? "Server error. Try again later." : null) ||
      error?.message ||
      "Unexpected error";

    const err = new Error(message);
    err.status = status;
    err.code = data?.code || "UNKNOWN";
    err.data = data;

    return Promise.reject(err);
  }
);

export default apiAdmin;
